import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterTag_template } from "./filterTag_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class imagesList_template extends vnTemplate {
    protected filterDate: filterDate_template;
    protected filterPreset: filterPreset_template;
    protected filterSimple: filterSimple_template;
    protected filterTag: filterTag_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected tagFilter: filterTag_template;
    protected imageHasWaterMarkFilter : filterDropdown_template;
    protected ratioFilter: filterDropdown_template;
    protected orientationFilter: filterDropdown_template;
    protected uploadSourceFilter: filterDropdown_template;
    protected aiUpscaledFilter: filterDropdown_template;

    protected getTemplateHtml(): string {
        return /* html */`
            <div id="list-references">
                <div class="sub-header filter-preset w-justify ">
                    ${this.filterPreset.getHtmlBuild()}
                </div>

                <div class="sub-header w-justify">
                    <div class="w-left">
                        ${this.tagFilter.getHtmlBuild()}
                        ${this.filterDate.getHtmlBuild()}

                        <div>
                            <label class="form-label">Watermark</label>
                            ${this.imageHasWaterMarkFilter.getHtmlBuild()}
                        </div>
                        <div>
                            <label class="form-label">Orientation</label>
                            ${ this.orientationFilter.getHtmlBuild() }
                        </div>
                        <div>
                            <label class="form-label">Ratio</label>
                            ${ this.ratioFilter.getHtmlBuild() }
                        </div>
                        <div>
                            <label class="form-label">Enhanced</label>
                            ${ this.aiUpscaledFilter.getHtmlBuild() }
                        </div>
                        <div>
                            <label class="form-label">Upload Source</label>
                            ${ this.uploadSourceFilter.getHtmlBuild() }
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-tags"></div>
                   <div id="selected-content_types"></div>
                </div>
            </div>

            <div class="list-header w-justify" >
                <div class="w-left">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-image-2" type="button">Create Images</button>
                    <button data-bind="disable: selectedImageCount() < 1, click: onClickBulkEdit" class="btn secondary icon i-image-2" type="button">Set Tags</button>
                    <button data-bind="visible: toggleAll,click: onClickAssignTags.bind($data, 'assign'),disable: selectedImageCount() < 1" class="btn secondary icon i-image-2" type="button">
                    Add More Tags
                    </button>

                    <button data-bind="visible: toggleAll,click: onClickAssignTags.bind($data, 'replace'),disable: selectedImageCount() < 1" class="btn secondary icon i-image-2" type="button">
                    Replace Tags
                    </button>

                    <!-- ko if: idBrand() == 6 && showEverettImport() -->
                         <button data-bind="click: onClickImport, disable: isEverettImportRunning" class="btn flex secondary icon i-image-2" type="button">
                            <img data-bind="visible: isEverettImportRunning" src="/assets/images/loading-2.svg" title="Importing Everett Images">
                            <span class="button-text">Import Everett Images</span>
                        </button>
                    <!-- /ko -->
                </div>
                <div class="w-center">
                    ${this.filterSimple.getHtmlBuild()}
                </div>
                <div class="w-right">
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results w-video-list list-article" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th>
                                <input type="checkbox" data-bind="checked: isToggleAllChecked" id="ToggleAll">
                                <label class="icon i-check" data-bind="event: { click: onClickToggleAll}" for="ToggleAll">Select All</label>
                            </th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span>Thumbnail</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'url') }, css: { 'list-sort-desc': orderByAndDirection()=='url_DESC', 'list-sort-asc': orderByAndDirection()=='url_ASC' }">URL</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tags') }, css: { 'list-sort-desc': orderByAndDirection()=='tags_DESC', 'list-sort-asc': orderByAndDirection()=='url_tags' }">Tags</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Uploaded On</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Updated On</span></th>
                        </tr>
                    </thead>
                    <!--<input type="checkbox" data-bind="checked: isCommentsDisabled" id="CommentsDisabled">
                    <label class="icon i-check" for="CommentsDisabled">Hide Comments</label>-->
                    <tbody data-bind="foreach: images">
                        <tr class="cursor">
                            <td  style="padding-left: 1rem;">
                                <input type="checkbox" data-bind="checked: isSelected, attr: { id: 'chk-' + id }" />
                                <label class="icon i-check" data-bind="attr: { for: 'chk-' + id }"></label>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <span data-bind="text: id"></span>
                                </a>
                            </td>
                            <td class="has-image" data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <img class="thumbnail" data-bind="attr: { src: url }"  alt="" />
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                   <span data-bind="text: name"></span>
                                </a>
                            </td>
                            <td>
                                <div class="flex" style="justify-content: space-between;">
                                    <!--<a style="flex: 1" data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                        <span data-bind="text: url"></span>
                                    </a> -->
                                    <a class="btn icon border only-icon i-link" target="_blank" rel="noopener noreferrer" data-bind="attr: { href: url }"></a>
                                </div>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                   <span data-bind="text: tags"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <span data-bind="text: dateCreated"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <span data-bind="text: dateUpdated"></span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isVisibleSetTags }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" id="clear-tags">
                        <div class="form-header">
                            <h3 class="form-title">Set Tags</h3>

                            <button data-bind="event: { click: onClickCancel }" type="button" class="close-button icon i-close-2 stay-enabled"></button>

                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                ${this.filterTag.getHtmlBuild()}
                            </div>
                            <div class="w-filters-selected">
                                <div id="filters-selected" class="filters-selected">
                                    <div id="bulk-tags-selected" data-bind="foreach: selectedTags"><span data-bind="text: $data"></span></div>
                                </div>
                            </div>

                        </div>

                        <div class="form-footer">

                            <button data-bind="event: { click: onClickCancel }" class="btn secondary " type="button">Cancel</button>

                            <button data-bind="event: { click: onClickTagSelectConfirm.bind($data, 'assign') }, disable: selectedTagCount() < 1" class="btn stay-enabled highlight" type="button">Assign Tags</button>

                            <button data-bind="event: { click: onClickTagSelectConfirm.bind($data, 'replace') }, disable: selectedTagCount() < 1" class="btn stay-enabled highlight" type="button">Replace Tags</button>


                        </div>
                    </div>
                </div>
        </div>
            `;
    }

    protected getTemplateName(): string {
        return "imagesList-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected initPartial(): void {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterDate = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.filterDate.getTemplateViewModel().startDate(null);
        this.filterDate.getTemplateViewModel().endDate(null);
        this.filterDate.toggleClearButton(true);
        this.filterDate.setLabel("Date Range");

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType("images");

        this.filterSimple = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.imageHasWaterMarkFilter = new filterDropdown_template('imageHasWaterMarkFilter', this.getTemplateViewModel(), this.caller);
        this.imageHasWaterMarkFilter.setLabel("WaterMark")
        this.imageHasWaterMarkFilter.setOptions([{id : 0, name: 'All'}, {id : 1, name: 'Yes'}, {id : 2, name: 'No'}]);

        this.ratioFilter = new filterDropdown_template("ratioFilter", this.getTemplateViewModel(), this.caller);
        this.ratioFilter.setLabel("Ratio");

        this.aiUpscaledFilter = new filterDropdown_template("aiUpscaledFilter", this.getTemplateViewModel(), this.caller);
        this.aiUpscaledFilter.setLabel("Enhanced");
        this.aiUpscaledFilter.setOptions([{id : 0, name: 'All'}, {id : 1, name: 'Yes'}, {id : 2, name: 'No'}]);

        this.orientationFilter = new filterDropdown_template("orientationFilter", this.getTemplateViewModel(), this.caller);
        this.orientationFilter.setLabel("Orientation");

        this.uploadSourceFilter = new filterDropdown_template("uploadSourceFilter", this.getTemplateViewModel(), this.caller);
        this.uploadSourceFilter.setLabel("Upload Source");

        this.filterTag = new filterTag_template("filterTag", this.getTemplateViewModel(), this.caller);
        this.filterTag.asMultipleSelectionMode();
        this.filterTag.setTagContainerId("bulk-tags-selected");
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            idBrand: ko.observable(null),
            orderBy: ko.observable("dateCreated"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            orderByDirection: ko.observable("DESC"),
            images: ko.observableArray([]),
            isSelected: ko.observable(false),
            toggleAll: ko.observable(false),
            selectedImages: ko.observableArray([]),
            isVisibleSetTags: ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(["article_list_self", "article_list_brand", 'article_edit'])),
            selectedTags: ko.observableArray([]),
            tagAssignMode: ko.observable("add"),
            isEverettImportRunning: ko.observable(false),
            isToggleAllChecked: ko.observable(false),
            showEverettImport: ko.observable(false),
            selectedImageCount: ko.pureComputed(() => {
                const imgs = self.getTemplateViewModel().images();
                return imgs.filter(img => ko.unwrap(img.isSelected)).length;
            }),
            viewUrl: (id: number): string => `/brand/${this.getTemplateViewModel().idBrand()}/images/view/${id}`,
            onClickAdd: () => {
                self.onClickAdd();
            },
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickView: (data, event) => {
                self.onClickView(data, event);
            },
            onClickBulkEdit:()=>{
                self.onClickBulkEdit();
            },
            onClickBulkEditCancel:()=>{
                self.onClickBulkEditCancel();
            },
            onClickSelected:(data, event)=>{
                self.onClickSelectedImages(data, event);
            },
            onClickCancel:()=>{
                self.onClickCancel();
            },
            onClickTagSelectConfirm:(data, item)=>{
                self.onClickTagSelectConfirm(data);
            },
            onClickAssignTags: function (data, event){
                self.onClickAssignTags(data);
            },
            onClickImport: function (data, event){
                self.onClickImport();
            },
            onClickToggleAll: function (){
                self.onClickToggleAll();
            },
            selectedTagCount: ko.pureComputed(() =>{
                return self.filterTag.getTemplateViewModel().tagObjs().length;
            })
        };
    }

    public getViewModelForRequest() {
        return {
            filters: {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                tags: this.tagFilter.getTagsForRequest(),
                watermark: this.getTemplateViewModel().imageHasWaterMarkFilter.selectedOption,
                ratio: this.getTemplateViewModel().ratioFilter.selectedOption,
                orientation: this.getTemplateViewModel().orientationFilter.selectedOption,
                aiUpscaled: this.getTemplateViewModel().aiUpscaledFilter.selectedOption,
                uploadSource: this.getTemplateViewModel().uploadSourceFilter.selectedOption,
            },
            orderBy: this.getTemplateViewModel().orderBy,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            imagePagination: this.getTemplateViewModel().pagination,
        };
    }

    public setViewModelFromRequest(urlParams) {
        if (urlParams != null) {
            if (urlParams.dateFilterType) {
                this.filterDate.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if (urlParams.startDateRange || urlParams.endDateRange) {
                this.filterDate.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }
            if (urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            let keywordString = urlParams.keywords;
            if (urlParams.keywords) {
                keywordString = urlParams.keywords.replaceAll("+", " ");
            }
            this.filterSimple.getTemplateViewModel().filterKeyword(keywordString);

            if (urlParams.tags) {
                this.tagFilter.setSelectedTagsFromRequestParams(urlParams.tags);
            } else {
                this.tagFilter.resetTagContainer();
            }

            this.imageHasWaterMarkFilter.setSelectedOption( typeof urlParams.watermark === "undefined" ? 0 : urlParams.watermark);

        }
    }

    public addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }

    public buildDatePickerCalendar() {
        this.filterDate.buildCalendar();
    }

    public onClickAdd() {
        this.caller.addImage();
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.imagesListReorder();
    }

    public onClickView(data, event) {
        if (event.target.id.indexOf("site-view") == -1) {
            this.caller.viewImage(data.id);
        }
    }

    public setAddButtonShown(isAddButtonShown: boolean) {
        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    private setDateFilters(startDate, endDate) {
        if (startDate) {
            startDate = new Date(startDate.replace(/-/g, "/"));
        }
        if (endDate) {
            endDate = new Date(endDate.replace(/-/g, "/"));
        }
        this.filterDate.setDateRange(startDate, endDate);
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    public setImages(images: Array<any>): void {

        const vm = this.getTemplateViewModel();
        const mapped = images.map((img: any) => {
            //const existing = existingById.get(img.id);
            return {
                ...img,
                isSelected: ko.observable(false),
                bulkEdit: ko.observable(false)
            };
        });

        vm.images(mapped);
    }

    public setIdBrand(idBrand) {
        this.getTemplateViewModel().idBrand(idBrand);
    }

    public onClickBulkEdit(){

        const vm = this.getTemplateViewModel();
        vm.isVisibleSetTags(true);
    }

    public onClickBulkEditCancel(){
        const vm = this.getTemplateViewModel();
        let images = this.getTemplateViewModel().images();
        const mapped = images.map((img: any) => {
            //const existing = existingById.get(img.id);
            return {
                ...img,
                isSelected: ko.observable(false),
                bulkEdit: ko.observable(false)
            };
        });
        vm.toggleAll(false);
        vm.images(mapped);
    }

    public onClickSelectedImages(data, event){
        data.isSelected(!data.isSelected());
    }


    private setTagPreset(idTag: number, tag: string): void {
        this.tagFilter.getTemplateViewModel().idTag(idTag);
        this.tagFilter.getTemplateViewModel().tag(tag);
        this.tagFilter.toggleCloseButton();
    }

    protected setTagFilter(tags,idElement = null){
        if(idElement != null && idElement === "filterTag"){
            this.filterTag.setTags(tags);
        }else{

            this.tagFilter.setTags(tags);
        }
    }

   public setRatios(ratios){
        this.ratioFilter.setOptions(ratios);
    }

    public setOrientations(orientations){
        this.orientationFilter.setOptions(orientations);
    }

    public setUploadSources(uploadSources, selectedUploadSource){
        this.uploadSourceFilter.setOptions(uploadSources);
        this.getTemplateViewModel().uploadSourceFilter.setSelectedOption(selectedUploadSource);
    }

    public setFilterSelectedItems(objFilter, urlParams) {
        let splitString = [];

        // Multi select filters.
        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public updateSelectedTags(){

        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObjs();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find(t => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if(tagSelected.tagType != null){
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({id: null, tag: tagSelected});
            }
        }


        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    public onClickAssignTags(mode: string){
        this.getTemplateViewModel().isVisibleSetTags(true);
        this.getTemplateViewModel().tagAssignMode(mode);
    }

    public onClickTagSelectConfirm(mode){
        let selectedImages = this.getTemplateViewModel().images().filter(img => img.isSelected());
        let tagsSelected = this.filterTag.getTemplateViewModel().tagObjs();
        this.caller.assignTagsToSelectedImages(mode, selectedImages, tagsSelected);
    }

    public onClickCancel() {
        const vm = this.getTemplateViewModel();
        this.filterTag.getTemplateViewModel().tagObjs([]);
        vm.selectedTags([]);
        this.filterTag.resetTagContainer();
        vm.isVisibleSetTags(false);
    }

    public onClickImport(){
        this.caller.importEverettImages();
    }

    public setIsEverettImportRunning(isRunning: boolean){
        this.getTemplateViewModel().isEverettImportRunning(isRunning);
    }

    public onClickToggleAll() {
        const vm = this.getTemplateViewModel();
        const images = vm.images();

        const allSelected = images.every((img: any) => ko.unwrap(img.isSelected));
        const newState = !allSelected;

        // Update existing observables instead of remapping
        images.forEach((img: any) => {
            if (ko.isObservable(img.isSelected)) {
                img.isSelected(newState);
            } else {
                img.isSelected = ko.observable(newState);
            }
        });

        // Update "Select All" checkbox
        vm.isToggleAllChecked(newState);
    }

    public setShowEverettImport(showEverettImport: boolean){
        this.getTemplateViewModel().showEverettImport(showEverettImport);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/imagesList_template.ts